// extracted by mini-css-extract-plugin
export default {"footer":"SiteFooter_footer__yl1eW","cvNote":"SiteFooter_cvNote__6LKJN","credit":"SiteFooter_credit__+gPEZ"};